export default {
  namespaced: true,
  state: () => ({
    cityList: [],
    regionList: [
      /*{value: 'region name', name: 'region name'}*/
    ],
    zoneList: [
      /*{value: 'zone name', name: 'zone name', region: 'region name'}*/
    ],

    oduRates: { oduRateSeriesList: [], oduRateModelList: [] },

    iduRates: { iduRateTypeList: [], iduRateModelList: [] }
  }),
  mutations: {
    SET_CITY_LIST(state, status = null) {
      if (status == null) {
        state.cityList = []
        state.regionList = []
        state.zoneList = []
      } else {
        state.cityList = [...status]

        state.regionList = []
        state.zoneList = []
        for (let i = 0; i < state.cityList.length; i++) {
          let infoList = state.cityList[i].name.split("_")
          if (infoList && infoList.length >= 2) {
            let existIndex = state.regionList.findIndex(item => item.value == infoList[0])
            if (existIndex < 0) {
              state.regionList.push({ key: infoList[0], value: infoList[0], name: infoList[0] })
            }

            existIndex = state.zoneList.findIndex(item => item.value == infoList[1])
            if (existIndex < 0) {
              state.zoneList.push({ key: infoList[1], value: infoList[1], name: infoList[1], region: infoList[0] })
            }
          }
        }
      }
    },

    SET_ODU_RATE: (state, status) => {
      state.oduRates = { ...status }
    },
    SET_IDU_RATE: (state, status) => {
      state.iduRates = { ...status }
    }
  },
  actions: {
    storeCityList({ commit }, status) {
      commit("SET_CITY_LIST", status)
    },
    storeOduRateList({ commit }, status) {
      commit("SET_ODU_RATE", status)
    },
    storeIduRateList({ commit }, status) {
      commit("SET_IDU_RATE", status)
    }
  },
  getters: {
    currentCityList: state => state.cityList,
    currentRegionList: state => state.regionList,
    currentZoneList: state => state.zoneList,
    currentOduRates: state => state.oduRates,
    currentIduRates: state => state.iduRates
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js